import SEOHead from '@/components/base/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleList from './components/ArticleList';
import DownloadCTA from './components/DownloadCTA';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91免费版',
    url: 'https://www.91free.com',
    description: '91免费版是值得信赖的免费软件下载平台，提供海量安全纯净的免费软件资源。',
    foundingDate: '2020',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'support@91free.com',
      availableLanguage: ['Chinese'],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91免费版',
    url: 'https://www.91free.com',
    description: '91免费版 - 海量免费软件下载平台，安全纯净无捆绑。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91free.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '91免费版 - 免费软件下载平台官网首页',
    description: '91免费版官方网站首页，提供系统工具、办公软件、多媒体、安全防护等八大分类的免费软件下载。',
    url: 'https://www.91free.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '91免费版',
      url: 'https://www.91free.com',
    },
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title="91免费版官网 - 海量免费软件下载平台"
        description="91免费版是众多用户首选的免费工具平台，提供完整功能体验，无需付费即可畅享全部核心服务。覆盖系统工具、办公软件、多媒体、安全防护等八大分类，3200+款精品软件，安全纯净无捆绑。"
        keywords="91免费版,91免费版下载,91免费版官网,91免费版最新版本,91免费版安装教程,91免费版功能介绍,91免费版使用指南,免费软件下载,免费工具平台"
        canonicalUrl="https://www.91free.com"
        ogTitle="91免费版官网 - 海量免费软件下载平台"
        ogDescription="无需付费即可畅享全部核心服务，安全纯净、海量资源。立即获取91免费版，享受流畅、便捷的使用体验。"
        schemaData={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <CategoryGrid />
        <ArticleList />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}